import CoachSpecialities from './CoachSpecialities'
export default CoachSpecialities
